



















































































import Vue from 'vue';
import {fromWeiEther, toBN} from '../utils/common';
import {PropType} from 'vue/types/options';
import axios from 'axios';
import {getConfigValue} from '@/contracts';
import i18n from '@/i18n';
import {TranslateResult} from 'vue-i18n';
import '@/mixins/general';
import Hint from '@/components/Hint.vue';
import { mapActions } from 'vuex';

interface CombatResult {
  isVictory: boolean;
  playerRoll: string
  enemyRoll: string;
  xpGain: string;
  skillGain: string;
  bnbGasUsed: string;
}

interface StoreMappedCombatActions {
  fetchIgoRewardsPerFight(): Promise<string>;
  fetchGasOffsetPerFight(): Promise<string>;
}

export default Vue.extend({
  components: {
    Hint
  },
  props: {
    fightResults: {
      type: Object as PropType<CombatResult>,
      default() {
        return {} as CombatResult;
      },
    },
    staminaUsed: {
      type: Number,
      default: 0,
    },
    isValor: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      skillPrice: 0,
      gasToken: '',
      showAds: false,
      igoDefaultReward: 0,
      gasOffsetPerFight: 0
    };
  },

  computed: {
    formattedOutcome(): TranslateResult {
      if(this.fightResults.isVictory) return i18n.t('combatResults.won');
      else return i18n.t('combatResults.lost');
    },
    formattedSkill(): string {
      return toBN(fromWeiEther(this.fightResults.skillGain)).toFixed(6);
    },
    formattedSkillNoIGO(): string {
      return toBN(fromWeiEther((parseInt(this.fightResults.skillGain, 10)).toString())).toFixed(6);
    },
    formattedSkillIGOReward(): string {
      return toBN(fromWeiEther((this.igoDefaultReward * this.formattedStaminaUsed).toString())).toFixed(6);
    },
    formattedSkillGasOffsetRewards(): string {
      return toBN(fromWeiEther((this.gasOffsetPerFight * this.formattedStaminaUsed).toString())).toFixed(6);
    },
    formattedStaminaUsed(): number {
      return this.staminaUsed / 40;
    },
    formattedXpGain(): string {
      return this.fightResults.xpGain + ' xp';
    }
  },
  methods: {
    ...(mapActions('combat', ['fetchIgoRewardsPerFight', 'fetchGasOffsetPerFight']) as StoreMappedCombatActions),
    async fetchPrices(): Promise<void> {
      const response = await axios.get('https://api.coingecko.com/api/v3/simple/price?ids=cryptoblades,binancecoin&vs_currencies=usd');
      this.skillPrice = response.data?.cryptoblades.usd;
    },
    formattedInUsd(value: string): string {
      if(!value) return '';
      return `($${value})`;
    },
    calculateSkillPriceInUsd(skill: number): number {
      if(!skill) return 0;
      return (skill as unknown as number * this.skillPrice as unknown as number);
    },
    calculatedSkillReward(): string {
      return toBN(fromWeiEther(this.fightResults.skillGain)).toFixed(6);
    },
    calculateSkillRewardNoIGO(): string{
      return toBN(fromWeiEther((parseInt(this.fightResults.skillGain, 10) - this.igoDefaultReward).toString())).toFixed(6);
    },
    calculateSkillIGOReward(): string{
      if(!this.igoDefaultReward) return '';
      return toBN(fromWeiEther((this.igoDefaultReward * this.formattedStaminaUsed).toString())).toFixed(6);
    },
    checkStorage() {
      if (process.env.NODE_ENV === 'development') this.showAds = false;
      else this.showAds = localStorage.getItem('show-ads') === 'true';
    },
  },
  async beforeMount(){
    this.igoDefaultReward = parseInt(await this.fetchIgoRewardsPerFight(), 10);
    this.gasOffsetPerFight = parseInt(await this.fetchGasOffsetPerFight(), 10);
  },
  async mounted() {
    this.gasToken = getConfigValue('currencySymbol') || 'BNB';
    await this.fetchPrices();
    this.igoDefaultReward = parseInt(await this.fetchIgoRewardsPerFight(), 10);
    await new Promise(f => setTimeout(f, 1000));
    this.checkStorage();
  },
});
